import { useState } from "react"
import { Bar } from "react-chartjs-2"
import {   Download, BarChart3  } from "lucide-react"
import { Chart as ChartJS, 
  CategoryScale, 
  LinearScale, 
  BarElement, 
  Title, 
  Tooltip, 
  Legend 
} from 'chart.js'

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)

export default function MessageVolume() {
  const [timeRange, setTimeRange] = useState("30")
  
  // Dummy data for the last 30 days
  const generateData = (days) => {
    const labels = []
    const smsData = []
    const whatsappData = []
    const emailData = []
    
    for (let i = days; i >= 1; i--) {
      labels.push(`${i}d ago`)
      smsData.push(Math.floor(Math.random() * 500) + 100)
      whatsappData.push(Math.floor(Math.random() * 400) + 50)
      emailData.push(Math.floor(Math.random() * 300) + 30)
    }
    
    return { labels, smsData, whatsappData, emailData }
  }
  
  const { labels, smsData, whatsappData, emailData } = generateData(parseInt(timeRange))

  const data = {
    labels,
    datasets: [
      {
        label: 'SMS',
        data: 0,
        // data: smsData,
        backgroundColor: '#3b82f6', // Blue
        borderRadius: 4,
      },
      {
        label: 'WhatsApp',
        data: 0,
        // data: whatsappData,
        backgroundColor: '#10b981', // Green
        borderRadius: 4,
      },
      {
        label: 'Email',
        data: 0,
        // data: emailData,
        backgroundColor: '#8b5cf6', // Purple
        borderRadius: 4,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 20,
        },
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.dataset.label}: ${context.raw} messages`
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  }

  return (
    <div className="bg-white shadow-sm border border-gray-200 rounded-lg overflow-hidden">
      <div className="flex justify-between items-center p-4 border-gray-200 border-b">
        <div>
          <h3 className="flex items-center font-medium">
            Message Volume
          </h3>
          <p className="text-gray-500 text-sm">Total messages sent over time</p>
        </div>
        <div className="flex items-center space-x-2">
          <select 
            value={timeRange}
            onChange={(e) => setTimeRange(e.target.value)}
            className="px-3 py-1 border border-gray-300 focus:border-blue-500 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
          >
            <option value="7">Last 7 days</option>
            <option value="14">Last 14 days</option>
            <option value="30">Last 30 days</option>
            <option value="90">Last 90 days</option>
          </select>
          <button className="hover:bg-gray-100 p-2 rounded-md text-gray-500 hover:text-gray-700">
            <Download className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="p-4 h-80">
        <Bar data={data} options={options} />
      </div>
      <div className="flex justify-between items-center bg-gray-50 p-4 border-gray-200 border-t">
        <div className="text-gray-600 text-sm">
          <span className="font-medium">Total messages:</span> 
          {' '}
          {smsData.reduce((a, b) => a + b, 0) + 
           whatsappData.reduce((a, b) => a + b, 0) + 
           emailData.reduce((a, b) => a + b, 0)} 
          {' '}sent
        </div>
        <div className="flex space-x-4">
          <div className="flex items-center text-sm">
            <span className="bg-blue-500 mr-1 rounded-full w-3 h-3"></span>
            SMS: {smsData.reduce((a, b) => a + b, 0)}
          </div>
          <div className="flex items-center text-sm">
            <span className="bg-green-500 mr-1 rounded-full w-3 h-3"></span>
            WhatsApp: {whatsappData.reduce((a, b) => a + b, 0)}
          </div>
          <div className="flex items-center text-sm">
            <span className="bg-purple-500 mr-1 rounded-full w-3 h-3"></span>
            Email: {emailData.reduce((a, b) => a + b, 0)}
          </div>
        </div>
      </div>
    </div>
  )
}